"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TenantQueryViewModel = void 0;
var class_transformer_1 = require("class-transformer");
var enums_1 = require("../users/enums");
var Enums = __importStar(require("./enums"));
var TenantQueryViewModel = /** @class */ (function () {
    function TenantQueryViewModel() {
        this.page = 1;
        this.status = Enums.TenantStatusEnum.ACTIVE_STATUS;
        this.direction = enums_1.PaginationSortEnum.ASC;
        this.operator = Enums.TdxSearchOperatorEnum.LIKE;
        this.property = Enums.FilterTenantPropertiesEnum.NAME;
        this.sortBy = Enums.SortableAndSearchableTenantModelPropertiesEnum.NAME;
        this.query = '';
        this.limit = 25;
    }
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Number)
    ], TenantQueryViewModel.prototype, "page", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], TenantQueryViewModel.prototype, "status", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], TenantQueryViewModel.prototype, "direction", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], TenantQueryViewModel.prototype, "operator", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], TenantQueryViewModel.prototype, "property", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], TenantQueryViewModel.prototype, "sortBy", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", String)
    ], TenantQueryViewModel.prototype, "query", void 0);
    __decorate([
        (0, class_transformer_1.Expose)(),
        __metadata("design:type", Number)
    ], TenantQueryViewModel.prototype, "limit", void 0);
    return TenantQueryViewModel;
}());
exports.TenantQueryViewModel = TenantQueryViewModel;
